import { BiSearch } from "react-icons/bi";
import { RiMenuUnfoldLine } from "react-icons/ri";
import BoxWrapper from "./boxWrapper";
import BoxItems from "./boxItems";
import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const boxClassName =
  "md:flex items-center cursor-pointer group text-dark-gray-text font-bold hover:bg-menu-background-hover dark:bg-base-input-gray hover:dark:bg-base-light-dark rounded-[5px] py-[12px] px-[16px]";
const iconClassName =
  "text-2xl mr-[10px] text-base-light-dark dark:text-base-input-dark-text group-hover:text-main-color";
const textClassName =
  "text-base-light-dark dark:text-base-input-dark-text group-hover:text-main-color";

const SearchBox = ({}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const location = useLocation();
  const navigate = useNavigate();

  const { gamePlatform } = useParams();

  const isStickyLeft = useSelector((state) => state.isStickyLeft);

  const currentPath = location.pathname;

  const list = [
    {
      icon: <BiSearch className={iconClassName} />,
      text: "Search",
      navigate: "search",
    },
  ];
  return (
    <BoxWrapper>
      {list.map((list, index) => {
        return (
          <BoxItems
            hiddenArrow
            icon={list.icon}
            text={list.text}
            path={list.navigate}
            wrapperTextClassName={`${isStickyLeft && "!hidden"}`}
            wrapperClassName={`md:bg-transparent bg-base-light-white dark:bg-base-input-gray`}
          />
        );
      })}
      <div
        className={`${boxClassName} hidden`}
        onClick={() => {
          navigate(`casino-group`);
        }}
      >
        <RiMenuUnfoldLine
          className={`${
            gamePlatform && gamePlatform !== "all" ? "text-main-color" : ""
          } ${iconClassName}`}
        />
        <span className={`${textClassName} ${isStickyLeft && "!hidden"}`}>
          {!gamePlatform || gamePlatform === "all"
            ? i18n("All providers")
            : gamePlatform}
        </span>
      </div>
    </BoxWrapper>
  );
};

export default SearchBox;
